/*
 * Module for duplicate employer look up
*/

rs.module("ui/controls/duplicateemployerlookup",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        
        var _popup;

        var _onDuplicatePopupClosedHandler;
        var _getLookupParametersFunction;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls) {

            // unpack js selectors
            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _backendUrls = backendUrls;

            _popup = $.js(_jsSelectors.popup);

            // hookup lookup link click event
            $.js(_jsSelectors.lookupLink).click(_lookupDuplicates);

            // Exported instance API
            return {
                onGetLookupParameters,
                onDuplicatePopupClosed
            };
        }

        //
        // API function to allow consumers to tell this module where to pull lookup parameters from
        //
        function onGetLookupParameters(getLookupParametersFunction) {
            _getLookupParametersFunction = getLookupParametersFunction;
        }

        //
        // API function to allow consumers to specify a call back function to execute after duplicate popup has been closed 
        //
        function onDuplicatePopupClosed(onDuplicatePopupClosed) {
            _onDuplicatePopupClosedHandler = onDuplicatePopupClosed
        }

        //
        // Perform duplicate lookup
        //
        function _lookupDuplicates() {
            
            // get the parameters to perform the lookup
            var parameters = _getLookupParametersFunction.call();

            // only perform the lookup if the parameters object is not null
            if (parameters) {

                // Throw error if object returned from _getLookupParametersFunction doesn't have all necessary values
                if (!parameters.hasOwnProperty("employerName") ||
                    !parameters.hasOwnProperty("fein") ||
                    !parameters.hasOwnProperty("employerID")) {
                    throw "JSON object returned from onGetLookupParameters() requires properties: 'employerName', 'fein', 'employerID'.";
                }

                // Show spinner
                $.js(_jsSelectors.ajaxSpinner).show();

                // perform lookup
                $.get(_backendUrls.duplicateLookup,
                    {
                        employerName: parameters.employerName,
                        fein: parameters.fein,
                        employerID: parameters.employerID
                    })
                    .done(function (result) {

                        if (result.noMatches) {
                            // since there were no matches, no need to show popup, just execute callback if it has been defined
                            if (_onDuplicatePopupClosedHandler) {
                                _onDuplicatePopupClosedHandler.call(_popup);
                            }
                        }
                        else {
                            // display results inside the popup
                            _popup.js(_jsSelectors.lookupResults).html(result);

                            // widen the popup to show grid results
                            _popup.js(_jsSelectors.modalContent).addClass(_cssClasses.widePopup);

                            // show the popup 
                            _popup.modal("show");
                        }

                        // hide the spinner after lookup is complete
                        $.js(_jsSelectors.ajaxSpinner).hide();
                    });
            }
        }

        //
        // Initialize lookup results (called once _LookupResults.cshtml is rendered)
        //
        function initializeResults(jsSelectors) {

            // listen for continue button clicks; call handler
            $.js(jsSelectors.continueButton, { required: false }).click(function () {
                if (_onDuplicatePopupClosedHandler) {
                    _onDuplicatePopupClosedHandler.call(_popup);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize,
            initializeResults
        };

        return exports;
    }
);